export type { RenderOptions, RenderResult, RenderWarning, WarningKind } from "./types.js";
export { renderHtml } from "./renderer.js";
export { stripPrivateSections } from "./filter.js";
export type { StripResult } from "./filter.js";
export { applyTemplate, DEFAULT_TEMPLATE } from "./template.js";
